module.exports = __webpack_public_path__ + "img/red_x.d0ed53ac.svg";